<fullscreen-page>
  <content-column>
    <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">
      <div class="d-flex flex-column np-header">
        <div class="d-flex flex-row p-2" style="align-items:center;">
          <dx-button (onClick)="openContainerEditPopup()"
                     stylingMode="outlined"
                     text="{{ 'Neuen Import Container' | translate }}"
                     type="default"/>
          <div class="flex-grow-1"></div>
          <dx-tag-box (onValueChanged)="onTagFilterChanged($event.value)"
                      [value]="selectedTags"
                      [items]="tagOptions"
                      [maxDisplayedTags]="2"
                      [searchEnabled]="true"
                      [showClearButton]="true"
                      [showSelectionControls]="true"
                      class="me-2"
                      placeholder="{{ 'Container-Tags' | translate }}"
                      stylingMode="outlined"/>
          <dx-text-box [(value)]="containerSearchText" mode="search"/>
        </div>
      </div>
      <div class="d-flex flex-row flex-grow-1 overflow-hidden">
        <div class="flex-grow-1 h-100 overflow-auto">
        <dx-card-view (onCardClick)="onContainerClicked($event)"
                      (onCardDblClick)="goToDetails($event.card?.data)"
                      [allowColumnReordering]="true"
                      [cardMinWidth]="250"
                      [dataSource]="filteredContainers"
                      [hoverStateEnabled]="true"
                      [selectedCardKeys]="selectedContainer ? [selectedContainer.id] : []"
                      cardFooterTemplate="footerTemplate"
                      cardsPerRow="auto"
                      class="w-100"
                      keyExpr="id"
                      noDataTemplate="noDataTextTemplate" >
          <div *dxTemplate="let catalog of 'noDataTextTemplate'">
            {{ 'Ups, noch nix da?' | translate }}
            <dx-button (onClick)="openContainerEditPopup()"
                       stylingMode="text"
                       text="{{ 'Hier geht es los' | translate }}"
                       type="default"/>
          </div>
            <dxo-card-view-card-header [visible]="true" template="headerTemplate"/>
            <div *dxTemplate="let params of 'headerTemplate'" class="np-card-header">
                <dx-button icon="overflow" stylingMode="text" type="default" (onClick)="onCatalogOverflowClicked( params.card?.data, $event)"></dx-button>
                <div class="chips np-card-tags">
                    <span *ngFor="let tag of containerTags(params.card?.data)"
                          [style.--np-tag-color]="tagColor(tag)"
                          class="chip np-card-tag">{{ tag }}</span>
                </div>
            </div>
      
            <dxo-card-view-search-panel [(text)]="containerSearchText" [visible]="false"/>
          <dxo-card-view-header-panel [visible]="false"/>
          <dxo-card-view-card-cover [altExpr]="altExpr" [imageExpr]="imageExpr" template="coverTemplate"/>
            <div *dxTemplate="let params of 'coverTemplate'"
                 [class.np-card-cover--empty]="!imageExpr(params.card?.data)"
                 class="np-card-cover">
                <img *ngIf="imageExpr(params.card?.data) as logoLink" [alt]="altExpr()" [src]="logoLink" class="dx-card-cover-image"/>
                <i *ngIf="!imageExpr(params.card?.data)" class="dx-icon dx-icon-imagethumbnail"></i>
                <div *ngIf="params.card?.data?.lastCatalogImport" class="np-card-change-bar">
                    <i class="dx-icon dx-icon-refresh"></i>
                    {{ 'Änderung am' | translate }} {{ params.card.data.lastCatalogImport | date:'dd.MM.' }}
                </div>
            </div>
          <dxo-card-view-selection mode="single"/>
            <dxo-card-view-paging [enabled]="false"/>
            <dxo-card-view-pager [visible]="false"/>

          <dxo-toolbar>
            <dxi-item location="before" name="searchPanel"></dxi-item>
          </dxo-toolbar>

            <dxi-card-view-column [allowSearch]="true"
                                caption="{{ 'Name' | translate }}"
                                dataField="name"/>
          <dxi-card-view-column [allowSearch]="false"
                                [calculateFieldValue]="calculateCatalogCount"
                                caption="{{ 'Kataloge' | translate }}"/>
          <dxi-card-view-column [allowSearch]="false"
                                caption="{{ 'Produkte' | translate }}"
                                dataField="productCount"/>
          <dxi-card-view-column [allowSearch]="true"
                                caption="{{ 'Notiz' | translate }}"
                                dataField="note"/>
          <dxi-card-view-column [allowSearch]="true"
                                [calculateFieldValue]="calculateDataSourceTags"
                                [visible]="false"
                                caption="{{ 'Container-Tags' | translate }}"/>

          <div *dxTemplate="let params of 'footerTemplate'">
              <div class="d-flex gap-2 card-footer align-items-center">
              <dx-button
                (onClick)="goToDetails(params.card?.data)"
                icon="chevrondoubleright"
                stylingMode="outlined"
                text="{{ 'Details' | translate }}"
                type="default">
              </dx-button>
                  <div class="flex-grow-1"></div>
            </div>
          </div>
        </dx-card-view>
        </div>

        <np-inspect-panel
          (containerSaved)="onContainerSaved($event)"
          (containerDeleted)="onContainerDeleted()"
          (containerDuplicated)="onContainerDuplicated($event)"
          [container]="selectedContainer"
          context="containerDetails">
        </np-inspect-panel>

      </div>
    </div>
  </content-column>
</fullscreen-page>

<np-container-edit
  (onSaved)="onContainerSaved($event)"
  [(visible)]="containerEditVisible"
  [container]="editedContainer"
  [editMode]="containerEditMode">
</np-container-edit>

<dx-context-menu
    #catalogContextMenu
    [dataSource]="contextMenuItems"
    showEvent=""
    [width]="200"
    (onItemClick)="itemClick($event)">
    <div *dxTemplate="let e of 'item'">
        <div>
            <span [ngClass]="e.icon"></span>
            <span *ngIf="e.items" class="dx-icon-spinright"></span> {{ e.text }}
        </div>
    </div>
</dx-context-menu>